export const SEOData = {
  siteTitle: "Cuvia",
  siteDescription: "Rezerva camere traditionale in Maramures cu facilitati premium.",
  siteUrl: "https://www.localhost:8000",
  siteAuthor: "Cuvia",
  ogImage: "https://www.localhost:8000/assets/images/farm_bg.png",
  twitterImage: "https://www.localhost:8000/assets/images/farm_bg.png",
  twitterCardType: "summary_large_image",
  seoVersion: "1.0.0",

  defaultMeta: {
    author: "Cuvia",
    robots: "index, follow",
    viewport: "width=device-width, initial-scale=1.0",
    locale: "ro_RO",
    canonical: "https://www.localhost:8000",
    "theme-color": "#ffffff",
    "mobile-web-app-capable": "yes",
    "meta-version": "1.0.0",
  },

  defaultOG: {
    "og:title": "Cuvia",
    "og:description": "Rezerva camere traditionale in Maramures cu facilitati premium.",
    "og:image": "https://www.localhost:8000/assets/images/farm_bg.png",
    "og:url": "https://www.localhost:8000",
    "og:type": "website",
    "og:site_name": "Cuvia",
    "og:locale": "ro_RO",
  },

  defaultTwitter: {
    "twitter:card": "summary_large_image",
    "twitter:title": "Cuvia",
    "twitter:description": "Rezerva camere traditionale in Maramures cu facilitati premium.",
    "twitter:image": "https://www.localhost:8000/assets/images/farm_bg.png",
    "twitter:site": "@cuvia",
    "twitter:creator": "@cuvia",
  },

  // ✅ Functii helper pentru generarea meta/og/twitter dinamice
  generateMeta({ pageTitle, description, canonical, keywords } = {}) {
    return {
      title: pageTitle || this.siteTitle,
      description: description || this.siteDescription,
      canonical: canonical || this.siteUrl,
      keywords: keywords || "",
      ...this.defaultMeta,
    };
  },

  generateOG({ pageTitle, description, image, url } = {}) {
    return {
      "og:title": pageTitle || this.siteTitle,
      "og:description": description || this.siteDescription,
      "og:image": image || this.ogImage,
      "og:url": url || this.siteUrl,
      ...this.defaultOG,
    };
  },

  generateTwitter({ pageTitle, description, image, cardType, siteHandle, creatorHandle } = {}) {
    return {
      "twitter:title": pageTitle || this.siteTitle,
      "twitter:description": description || this.siteDescription,
      "twitter:image": image || this.twitterImage,
      "twitter:card": cardType || this.twitterCardType,
      "twitter:site": siteHandle || "@cuvia",
      "twitter:creator": creatorHandle || "@cuvia",
      ...this.defaultTwitter,
    };
  },
};
